'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearAgo.js
// module id = 224
// module chunks = 0